import { TYPES } from './types';
import { k3docService } from '../services';

// Get all flows
export const getK3Flows = (query = {}) => async dispatch => {
  try {
    const res = await k3docService.getK3Docs({ ...query, type: 'flow' });
    dispatch({
      type: TYPES.ACTION_GET_K3FLOWS_SUCCESS,
      payload: res.data.data.docs
    });
  } catch (err) {
    dispatch({
      type: TYPES.ACTION_GET_K3FLOWS_FAIL,
      payload: err.response?.data || { message: 'Error getting flows' }
    });
  }
};

// Get a single flow
export const getK3Flow = (id) => async dispatch => {
  try {
    const res = await k3docService.getK3Docs({ id });
    dispatch({
      type: TYPES.ACTION_GET_K3FLOW_SUCCESS,
      payload: res.data.data.docs[0]
    });
  } catch (err) {
    dispatch({
      type: TYPES.ACTION_GET_K3FLOW_FAIL,
      payload: err.response?.data || { message: 'Error getting flow' }
    });
  }
};

// Set flows (create/update/delete)
export const setK3Flows = (flows, query = {}) => async dispatch => {
  try {
    const res = await k3docService.setK3Docs(flows, query);
    dispatch({
      type: TYPES.ACTION_SET_K3FLOWS_SUCCESS,
      payload: res.data.data
    });
  } catch (err) {
    dispatch({
      type: TYPES.ACTION_SET_K3FLOWS_FAIL,
      payload: err.response?.data || { message: 'Error setting flows' }
    });
  }
}; 